import { Modal } from 'antd';

const PackingListPrintViewModal = ({ pdfLink, show, setShow }) => {
  return (
    <Modal
      visible={show}
      onCancel={() => setShow(false)}
      footer={false}
      width={1500}
      style={{ top: 20 }}
    >
      <div className="mt-10">
        <iframe
          src={pdfLink}
          width="100%"
          height={"1123px"}
          title="PDF Viewer"
          id="your-iframe-id"
        />
      </div>
    </Modal>
  );
};

export default PackingListPrintViewModal;